import {
  TenantConfiguration,
  TenantConfigurationControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface Params {
  configuration: TenantConfiguration;
  xTENANTID?: string;
}

/**
 * @author Shrinivas Mandhare
 */
export const useCreateTenantConfiguration = () =>
  useMutationWithLoading(async (params: Params) =>
    new TenantConfigurationControllerApi(
      getConfigObject()
    ).createTenantConfiguration(params.configuration, params.xTENANTID)
  );
